import { prop, compose } from 'ramda';

export const list = prop('list');
export const next = prop('next');
export const previous = prop('previous');
export const current = prop('current');
export const showPrevButton = prop('showPrevButton');
export const showNextButton = prop('showNextButton');
export const offset = prop('offset');

export const title = compose(
  prop('title'),
  current,
);
export const image = compose(
  prop('image'),
  current,
);
